import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useStatusesList() {
  // Use toast
  const toast = useToast();

  const refStatusListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    //{ key: "id", label: "編號", sortable: true },
    { key: "name", stickyColumn: true, label: "狀態名稱", sortable: true },
    { key: "sort_order", label: "排序", sortable: true },
    { key: "updated_at", label: "修改時間", sortable: true },
    { key: "created_at", label: "創建時間", sortable: true },
    { key: "actions", label: "操作" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("sort_order");
  const isSortDirDesc = ref(false);

  const dataMeta = computed(() => {
    const localItemsCount = refStatusListTable.value
      ? refStatusListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refStatusListTable.value.refresh();
  };

  const statusesList = ref(null);

  watch(
    [currentPage, perPage, searchQuery],
    () => {
      refetchData();
    }
  );

  const fetchProductStatuses = (ctx, callback) => {

    store
      .dispatch("status/fetchStatuses", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { product_statuses, total } = response.data;
        callback(product_statuses);
        totalRow.value = total;
        statusesList.value = product_statuses
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
 
  return {
    fetchProductStatuses,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    statusesList,
    refStatusListTable,
    ability,
    refetchData,
  };
}
